ApiError = require 'network/api-error'
{ MinimalCanonicalCard } = require 'views/canonical-card/canonical-card-components'
ModelCache = require 'db/model-cache'
ModelLoader = require 'db/model-loader'
Util = require 'lib/util'
startDecayingInterval = require 'lib/util/decaying-interval'

class PopulatingMinimalCanonicalCard extends MinimalCanonicalCard

  constructor: (props) ->
    super(props)
    @state = @_loadAndHydrateState()
    if @props.isPolling
      @_cancelInterval = startDecayingInterval(@_loadModel.bind(@), {
        resetAfterMouseMove: true
        intervals: [
          {
            iterations: 2
            timeout: Util.getMs(seconds: 30)
          }
        ]
      })

  componentWillMount: ->
    @_mounted = true

  componentWillUnmount: ->
    @_mounted = false
    @_cancelInterval?()

  _mapToState: ({ card, board }) ->
    badges = card?.get('badges')
    {
      cardName: card?.get('name') || @props.cardName
      cardDue: badges?.due
      cardDueComplete: badges?.dueComplete
      cardUrl: card?.get('url') || @props.cardUrl
      boardName: board?.get('name') || @props.boardName
      boardBgColor: board?.getPref('backgroundColor')
      boardBgBottomColor: board?.getPref('backgroundBottomColor')
      boardBgBrightness: board?.getPref('backgroundBrightness')
      boardBgImage: Util.smallestPreviewBiggerThan(board?.getPref('backgroundImageScaled'), 250, 130)?.url ? board?.getPref('backgroundImage')
      boardUrl: board?.get('url') || @props.boardUrl
      listName: card?.getList()?.get('name') || @props.listName
      isWide: @props.isWide
    }

  _loadModel: ->
    ModelLoader.loadCanonicalCardData(@props.idCard)
    .catch ApiError.NotFound, ApiError.Unauthorized, =>
      @_cancelInterval?()
      ModelLoader.loadBoardMinimal(@props.idBoard)
    .then =>
      if @_mounted
        card = ModelCache.get('Card', @props.idCard)
        board = ModelCache.get('Board', card?.get?('idBoard') || @props.idBoard)
        @setState @_mapToState({
          board,
          card
        })


  _loadAndHydrateState: (props) ->
    card = ModelCache.get('Card', @props.idCard)
    board = ModelCache.get('Board', card?.get?('idBoard') || @props.idBoard)
    if !board || !card then @_loadModel()
    @_mapToState({ card, board })

module.exports = {
  PopulatingMinimalCanonicalCard
}



// WEBPACK FOOTER //
// ./app/scripts/views/canonical-card/populating-canonical-card.coffee